export const itemsData = [
    {
        icon: "trophy",
        title: "Desarrolla tu portafolio",
        description: "Nuestros cursos te brindarán la oportunidad de crear proyectos reales que te permitirán demostrar tus habilidades y crear un portafolio impresionante. Con la retroalimentación de nuestros profesionales, estarás listo para presentar tus proyectos a futuros empleadores o clientes.",
    },
    {
        icon: "dollar",
        title: "¡Cursos Gratuitos!",
        description: "Ofrecemos acceso gratuito a todos nuestros cursos de programación y diseño web. Sin cargos ocultos ni costos adicionales. Aprende a tu propio ritmo sin preocupaciones financieras.",
    },
    {
        icon: "clock outline",
        title: "Cursos Cortos",
        description: "Nuestros cursos son de corta duración para que puedas aprender de manera rápida y efectiva. Cada lección tiene una duración máxima de 15 minutos y nuestros cursos tienen una duración de entre 10 y 30 horas.",
    },
    {
        icon: "key",
        title: "Acceso 24/7",
        description: "Accede a nuestros cursos en cualquier momento, desde cualquier lugar y en cualquier dispositivo. Aprende a tu propio ritmo y sin restricciones de tiempo.",
    },
    {
        icon: "comment alternate outline",
        title: "Aprendizaje colaborativo",
        description: "Aprende de los demás y mejora tus habilidades en programación y diseño web con la ayuda de nuestros profesionales y comunidad de estudiantes. Comparte tus dudas y recibe retroalimentación para mejorar tus proyectos.",
    },
    {
        icon: "lightbulb outline",
        title: "Aprende habilidades valiosas",
        description: "Nuestros cursos están diseñados para enseñarte habilidades valiosas en programación y diseño web. Aprende las últimas tendencias y herramientas para mejorar tus habilidades y mantener tu perfil actualizado en el mercado laboral.",
    },
];